<script lang="ts">
  import { afterUpdate } from "svelte";
  export let target: number;
  let element: HTMLElement;
  let currentNumber: number = 0;

  function animateResultCount(target: number, elem: HTMLElement) {
    if (currentNumber < target) {
      var interval = setInterval(function () {
        elem.innerHTML = currentNumber.toString();
        if (currentNumber >= target) {
          clearInterval(interval);
          return;
        }
        currentNumber++;
      }, 30);

      if (currentNumber > target) {
        elem.innerHTML = target.toString();
      }
    }
  }

  afterUpdate(() => {
    animateResultCount(target, element);
  });
</script>

<div bind:this={element}>{currentNumber}</div>
